module.exports = __webpack_public_path__ + "static/media/preferred-vendor.85ae21c6.png";